import { FC } from 'react'
import { TagTypes } from './tag.types'

export const Tag: FC<TagTypes> = ({ label }) => {
  return (
    <div className="me-2 inline-block w-max items-center rounded border bg-grey-10 p-1.5 text-center font-montserrat text-[10px] text-dark-gray">
      {label}
    </div>
  )
}